import { AxiosError, AxiosResponse } from "axios";
import nodeProvider from "../providers/node.provider";
import protheusProvider from "../providers/protheus.provider";

export class ScheduleService {
  public async index(token: string | null, month: number, year: number, period: boolean, analista?: string, recno?: number): Promise<AxiosResponse> {
    const params: any = {
      token,
      month,
      year,
      period,
      _t: new Date().getTime() // Cache busting
    }

    if (analista) { params.analista = analista }
    if (recno) { params.recno = recno }

    try {
      const response = await nodeProvider.get('/schedule', { params });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }


}